import React from 'react';
import { Calendar, Wallet, MessageSquare } from 'lucide-react';
import { CAMP_SEASON, WEEKLY_SESSIONS } from './summerCampContent';
export function SummerCampWeeklySessions() {
  return <section id="weekly-sessions" className="py-24 bg-off-white" data-id="element-3300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3301">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-3302">
          <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-4" data-id="element-3303">
            <Calendar className="w-4 h-4" data-id="element-3304" />
            {CAMP_SEASON.year} Schedule
          </div>
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-3305">
            Camp Dates & Weekly Sessions
          </h2>
          <p className="text-xl text-gray-warm" data-id="element-3306">
            Choose the week or weeks that work best for your family. A $100
            deposit reserves your child's spot for each selected camp week.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-3307">
          {WEEKLY_SESSIONS.map(session => <div key={session.week} className="bg-paper rounded-2xl p-6 border border-subtle-gray hover:border-storm-red hover:shadow-xl transition-all flex flex-col" data-id="element-3308">
              <div className="flex items-center justify-between mb-4" data-id="element-3309">
                <span className="font-display text-2xl text-storm-red" data-id="element-3310">
                  Week {session.week}
                </span>
                <span className="text-xs font-bold text-gray-warm uppercase tracking-wide bg-off-white px-3 py-1 rounded-full border border-subtle-gray" data-id="element-3311">
                  {session.days}
                </span>
              </div>
              <div className="mb-6 flex-grow" data-id="element-3312">
                <p className="text-xl font-bold text-ink mb-2 leading-tight" data-id="element-3313">
                  {session.short}
                </p>
                <p className="text-sm text-gray-warm mb-1" data-id="element-3314">
                  {session.dates.split(', ')[1]}
                </p>
                <p className="text-sm text-gray-warm" data-id="element-3315">{CAMP_SEASON.hours}</p>
              </div>
              <a href={session.depositUrl} className="btn-primary w-full text-center text-base py-3" data-id="element-3316">
                <span className="hidden sm:inline" data-id="element-3317">
                  Reserve Week {session.week} With $100 Deposit
                </span>
                <span className="sm:hidden" data-id="element-3318">
                  $100 Deposit - Week {session.week}
                </span>
              </a>
            </div>)}
        </div>

        <div className="max-w-3xl mx-auto mb-12 bg-paper rounded-2xl p-6 border border-subtle-gray flex items-start gap-4" data-id="element-3319">
          <Wallet className="w-6 h-6 text-storm-red shrink-0 mt-1" data-id="element-3320" />
          <p className="text-gray-warm" data-id="element-3321">
            <span className="font-bold text-ink" data-id="element-3322">
              A $100 deposit is required to reserve each camp week.
            </span>{' '}
            Remaining balance details will be confirmed by Storm Taekwondo.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-ink text-white rounded-2xl p-8 text-center" data-id="element-3323">
          <p className="text-lg mb-4" data-id="element-3324">
            <span className="font-bold" data-id="element-3325">Ready to sign up?</span> Reserve your
            child's camp week with a $100 deposit. Text or call with questions.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-3326">
            <a href="#weekly-sessions" className="btn-primary" data-id="element-3327">
              <Wallet className="w-5 h-5 mr-2" data-id="element-3328" />
              Choose a Camp Week
            </a>
            <a href={`sms:${CAMP_SEASON.registrationPhone.replace(/-/g, '')}`} className="btn-outline border-white text-white hover:bg-white hover:text-ink" data-id="element-3329">
              <MessageSquare className="w-5 h-5 mr-2" data-id="element-3330" />
              Text With Questions
            </a>
          </div>
        </div>
      </div>
    </section>;
}